<template>
  <div>
    <div>
      <a-form layout="inline">
        <a-form-item label="样式类型">
            <a-select v-model="config.style" dropdown-class-name="durk" style="width:120px">
              <a-select-option :value="1">正方形</a-select-option>
              <a-select-option :value="2">长方形</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="宽度">
            <a-input v-model="config.width" class="ghost" addon-after="px"></a-input>
          </a-form-item>
          <a-form-item label="推广位">
          <a-select v-model="config.ap" dropdown-class-name="durk" style="width:200px">
            <a-select-option :value="0">无</a-select-option>
            <a-select-option v-for="item in aps" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="createAndHelper">生成并复制代码</a-button>
          </a-form-item>
      </a-form>
    </div>
    <div class="js-box">{{js}}</div>
    <div class="text-center">效果预览</div>

    <div class="ex-panel scroll-panel">
      <div class="aiviy-style-1" :style="{width: unionAdsConfig.width + 'px'}">
        <div id="aiviy-content" ref="aiviy-content" >
          <div class="item" v-for="(item, index) in unionAds" :key="index"><img :src="$store.state.assetUrl + item.img"/></div>
        </div>
      </div>
    </div>
    
    <div class="rule">
      <h4>使用说明：</h4>
      <p>1、广告需要固定宽度，可自行修改为需要的宽度，正方形样式中广告将以300*300比例展示，建议用于侧边展示；长方形样式以750*300比例展示，建议用于banner或文章内容中。</p>
      <p>2、选择配置后点击《生成嵌入代码》即可生成对应js代码</p>
      <p>3、复制代码后将代码完整粘贴到自己的页面代码中，保存后刷新浏览器即可看到广告</p>
    </div>
    <div class="mt-1">
      <div class="item-title fixed"><span class="pull-left">推广位列表</span> <a-button class="pull-right" @click="editAp(null)" type="primary">新增推广位</a-button></div>
        <a-table :columns="columns" :data-source="aps" size="middle" row-key="id" :pagination="false" class="transpanret-table">
          <span slot="action" slot-scope="record">
            <a @click="editAp(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm
              title="是否确认要删除该推广位，删除后已推广的链接将不再被记录?"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delAp(record)"
            >
              <a >删除</a>
            </a-popconfirm>
          </span>
        </a-table>
    </div>
    <a-modal v-model="formVisible" title="编辑推广位" :closable="null" width="330px" centered>
        <div slot="footer" class="white-wrap">
          <a-button type="default" @click="formVisible = false" shape="round">
            取消
          </a-button>
          <a-button key="submit" type="primary"  @click="submitAp" shape="round">
            确认
          </a-button>
      </div>
      <div class="white-wrap">
        <a-form-item label="推广位名称">
          <a-input v-model="form.name" placeholder="请输入推广位名称" class="ract-item"></a-input>
        </a-form-item>
      </div>
    </a-modal>
  </div>
</template>

<script>
let self;
let columns = [
  {
    title:"#",
    dataIndex:"id"
  },
  {
    title:"推广位名称",
    dataIndex:"name"
  },
  {
    title:"点击量",
    dataIndex:"click_count"
  },
  {
    title:"收益",
    dataIndex:"commission"
  },
  {
    title:"创建时间",
    dataIndex:"created_at"
  },
  {
    title:"操作",
    scopedSlots: { customRender: 'action' }
  },
];
export default {
  name: 'jaAdverts',
  data(){
    return {
      columns,
      tpl:``,
      js:'',
      config:{
        style:1,
        width:300,
        ap:0
      },
      aps:[],
      form:{},
      formVisible:false,
      unionAdsConfig:{
        width:300
      },
      unionAds:[],
      unionAdTimer:null
    }
  },
  mounted(){
    self = this;
    this.tpl = `<div id="aiviy-union-ad-#style#" style="width: #width#px;"></div><script src="https://www.aiviy.com/assets/js/union.js" id="aiviy-union-js-#style#" data-ap="#ap#" data-unionid="#unionid#" data-container="aiviy-union-ad-#style#" data-style="#style#"><`+`/script>`;
    this.createJs();
    this.getAps();
    this.getUnionAds()
  },
  methods:{
    createAndHelper(){
      this.createJs()
      this.$helper.copyText(this.js)
      this.getUnionAds()
    },
    createJs(){
      let js = this.tpl.replace('#width#', this.config.width);
      js = js.replace('#unionid#', this.$store.state.authInfo.id);
      js = js.replace(/#style#/g, this.config.style);
      js = js.replace('#ap#', this.config.ap);
      this.js = js;
    },
    getAps(){
      this.$http.get("getAps").then((res)=>{
        self.aps = res.data;
      });
    },
    editAp(record){
      this.form = {...record}
      this.formVisible = true;
    },
    submitAp(){
      this.$http.post("saveAp", this.form).then((res)=>{
        self.$message.success(res.msg);
        self.getAps();
        self.formVisible = false;
      });
    },
    delAp(record){
      this.$http.post("delAp", {id:record.id}).then((res)=>{
        self.$message.success(res.msg);
        self.getAps();
      });
    },
    getUnionAds(){
      fetch('https://www.aiviy.com/api/unionAds?style='+this.config.style + "&unionid="+this.$store.state.authInfo.id).then(function(response) {
            return response.json()
      }).then((res)=>{
        self.unionAds = res.data
        self.unionAdsConfig = {...self.config}
        self.loop()
      });
    },
    loop() {
        self.unionAdTimer && clearInterval(self.unionAdTimer)

        var itemWidth = this.unionAdsConfig.width;
        var maxWidth = itemWidth * (this.unionAds.length -1);

        var curLeft = 0;
        var content = this.$refs["aiviy-content"];
        
        this.unionAdTimer = setInterval(function() {
            content.style = `transform: translate3d(${curLeft}px, 0px, 0px);`;
            if(curLeft <= -maxWidth){
                curLeft = 0;
            }else{
                curLeft -= itemWidth;
            }
            
        },3500)
        
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .js-box{
    padding: 1rem;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    text-align: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .rule{
    margin-top: 1rem;
    font-size: 12px;
  }
  .item-title{
    border-top: 1px dashed rgba(255, 255, 255, 0.1);
    padding-top: 10px;
    margin: 40px auto 10px auto;
  }

  .ex-panel{
    margin-top: 1rem;
    text-align: center;
    width: 100%;
    max-height: 350px;
    padding: 20px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    overflow: auto;
  }
  .aiviy-style-1{
      position: relative;
      overflow: hidden;
      display: inline-block;
  }
  .aiviy-style-1 #aiviy-content{
      white-space: nowrap;
      transition: all 0.35s;
  }
  .aiviy-style-1 .item{
      position: relative;
      display: inline-block;
      width: 100%;
  }
  .aiviy-style-1::after{
      position: absolute;
      content: '广告';
      color: #fff;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 15px;
      font-size: 12px;
      padding: 1px 6px;
      top: 10px;
      right: 10px;
      line-height:normal;
  }
  .aiviy-style-1 .item.active{
      z-index: 10;
  }
  .aiviy-style-1 img{
      width: 100%;
  }
</style>
